import React from 'react';
import { ZdsAccordion, ZdsDivider, ZdsLink } from '@zig-design-system/ui-components-react';
import Translation from '../../../Shared/components/Translation';
const FaqResult = ({ hit }) => {
    const contentLength = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? 120
        : 340;
    const content = hit._source.content.length > contentLength
        ? hit._source.content.substring(0, contentLength - 3) + '...'
        : hit._source.content;
    return (React.createElement("div", null,
        React.createElement(ZdsAccordion, { "icon-name": "plus" },
            React.createElement("div", { slot: "header" }, hit._source.title),
            React.createElement("div", { slot: "body" },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
                React.createElement(ZdsLink, { link: hit._source.url, color: "secondary", className: "zds-margin-top-2" },
                    React.createElement(Translation, { item: "tx_zigsitepackage.search.readMore" })))),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
export default FaqResult;
